<template>
  <div class="className">
    <el-card class="anoCard">
      <div class="title">基本信息：</div>
      <el-form
        ref="dialogForm"
        :model="dialogForm"
        :rules="formRule"
        label-width="180px"
      >
        <el-form-item label="活动名称:" prop="name">
          <el-input
            style="width: 220px"
            v-model="dialogForm.name"
            placeholder="请输入活动名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="景区:" prop="company_id">
          <el-select v-model="dialogForm.company_id" :disabled="setDis" @change="changeCom" placeholder="请选择景区">
            <el-option
              v-for="item in companyList"
              :key="item.id"
              :label="item.companyName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <div>5.0景区名称：{{ dialogForm.five_name }}</div>
        </el-form-item>
        <el-form-item label="活动宣传图:" prop="fileProp">
          <div class="file-tip">图片要求：jpg, jpeg, png格式，小于2M</div>
          <UploadFile
            :limit="1"
            :fileList="fileList"
            :fileMaxSize="2"
            :accept="'.jpg,.jpeg,.png'"
            :value="dialogForm.fileProp"
            :httpRequest="uploadFile"
            :handleRemove="handleRemove"
          >
          </UploadFile>
        </el-form-item>
        <el-form-item label="活动banner:" prop="fileProp2">
          <div class="file-tip">图片要求：jpg, jpeg, png格式，小于2M，最多九张</div>
          
          <UploadFile
              :limit="9"
              :fileList="fileList2"
              :fileMaxSize="2"
              :multiple="true"
              :accept="'.jpg,.jpeg,.png'"
              :value="dialogForm.fileProp2"
              :httpRequest="uploadFile2"
              :handleRemove="handleRemove2"
            >
            </UploadFile>
        </el-form-item>
        <el-form-item label="活动详情图:" prop="fileProp3">
          <div class="file-tip">图片要求：jpg, jpeg, png格式，小于2M，最多九张</div>
          <UploadFile
              :limit="9"
              :fileList="fileList3"
              :fileMaxSize="2"
              :multiple="true"
              :accept="'.jpg,.jpeg,.png'"
              :value="dialogForm.fileProp3"
              :httpRequest="uploadFile3"
              :handleRemove="handleRemove3"
            >
            </UploadFile>
        </el-form-item>
        <el-form-item label="活动日期范围" required prop="dateRange">
          <el-date-picker
            v-model="dialogForm.dateRange"
            type="daterange"
            align="right"
            unlink-panels
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            @change="dateChange"
            :clearable="true"
          >
          </el-date-picker>
        </el-form-item>
        
        <div class="titlas">
          <span class="title">奖池设置：</span>
        </div>
        <el-form-item label="5.0营销活动:" prop="five_activity_id">
          <el-select v-model="dialogForm.five_activity_id" @change="changeAct" placeholder="请选择景区">
            <el-option
              v-for="item in fiveActiveList"
              :key="item.id"
              :label="item.activityName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <div>5.0景区名称：{{ dialogForm.storeName }}</div>
        </el-form-item>
        <el-form-item label="">
          <div>兑换码总数量：{{ dialogForm.five_activity_num }}</div>
        </el-form-item>
        <el-form-item label="">
          <div>可用兑换码数量：{{ dialogForm.redemption_codes_num }}</div>
        </el-form-item>
        <el-form-item label="抽中概率:" prop="probability">
          <el-input
            style="width: 187px"
            v-model.number="dialogForm.probability"
            placeholder="请填写抽中概率0-100"
          ></el-input><span class="persent">%</span>
        </el-form-item>
        <el-form-item label="上架状态:">
          <el-switch
            v-model="dialogForm.enable"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number 
            v-model="dialogForm.sortValue"
            :min="1"
            controls-position="right"
            size="small"
          />
        </el-form-item>
        <el-form-item label="适用卡牌:">
          <el-radio-group v-model="dialogForm.resource">
            <el-radio :label="0">全部卡牌</el-radio>
            <el-radio :label="1">部分卡牌</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="titlas">
          <span class="title">活动范围</span>
        </div>
        <div class="map">
          <Map1 
            :load="getMap1AreaSt"
            :mapCenter="mapCenter"
            :zoom="16"
            :maxzoom="19"
            :minzoom="6"
            :islimit='true'>
          </Map1>
        </div>
        <el-form-item>
          <span class="dialog-footer">
            <el-button @click="reset">取消</el-button>
            <el-button type="primary" @click="submitForm('dialogForm')">提交</el-button>
          </span>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getCompanyList, getZeusCompanyApi, uploadFiles, createActivityApi, updateActivityApi, getFiveActivityListApi } from '@/api/radio'
import { transTime } from '@/utils/transTime'
import Map1 from '@/components/map/map1'
import { getImgName } from "@/utils/cutImgName"
import UploadFile from '@/components/uploadFile.vue'
export default {
  components: { Map1, UploadFile },
  data() {
    const validateProbability = (rule, value, callback) => {
      if (value === '' || value === null || value === undefined) {
        callback(new Error('概率值不能为空'));
      } else if (isNaN(value)) {
        callback(new Error('必须输入数字'));
      } else if (value < 0 || value > 100) {
        callback(new Error('概率值必须在0到100之间'));
      } else {
        callback();
      }
    }
    return {
      getImgName,
      transTime,
      setDis: false,
      mapCenter: [121.506427,31.245275],
      businessList: [],
      formRule: {
        name: {
          required: true,
          message: "请输入活动名称",
          trigger: "blur",
        },
        company_id: {
          required: true,
          message: "请选择景区",
          trigger: "blur",
        },
        probability: [{ required: true, message: '概率值不能为空', trigger: 'blur' },
        { validator: validateProbability, trigger: 'blur' }
        ],
        dateRange: { required: true, message: '请选择时间', trigger: 'change' },
        fileProp: { required: true, message: '请上传文件', trigger: 'change'},
        fileProp2: { required: true, message: '请上传至少一个文件', trigger: 'change'},
        fileProp3: { required: true, message: '请上传至少一个文件', trigger: 'change'},
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      queryForm: {
        page: 1,
        pageSize: 10,

        timeRange: "0", // 时间范围(默认是查询2小时内的数据)
      }, // 搜索条件表单
      fiveActiveList: [],
      dialogForm: {
        fileProp: '',
        fileProp2: '',
        fileProp3: '',
        enable: true,
        resource: 0,
        five_name: '',
        storeName: '',
        five_company_id: null,
        five_activity_id: null,
        name: '',
        probability: null,
        company_id: null,
        five_activity_num: null,
        redemption_codes_num: null,
        dateRange: [], // 时间段
        sortValue: '',
      }, // 模态框展示的数据
      fileList: [],
      fileList2: [],
      fileList3: [],
      layout: "total, sizes, prev, pager, next, jumper", // 分页数据
      total: 0, // 总数据条数
      tableData: [],
      storeList: [], // 5.0景区列表
      companyList: [],
      remark: null,
      type: '',
      id: null,
      polygonAreas: null,
      start: '',
      end: '',
      maxValue: null,
      five_start_time: '',
      five_end_time: '',
    };
  },
  async created() {
    this.type = this.$route.query.type
    // this.storeList = JSON.parse(this.$route.query.storeList)
    this.storeList = JSON.parse(sessionStorage.getItem('departStore'))
    this.setDis = false
    if(this.type == 'edit'){
      this.setDis = true
      // let param = JSON.parse(this.$route.query.row)
      let param = JSON.parse(sessionStorage.getItem('depart'))
      console.log(333, param)
      this.id = param.id
      this.dialogForm.sortValue = param.order_by
      this.dialogForm.name = param.name
      this.dialogForm.company_name = param.companyName
      this.dialogForm.five_activity_id = param.five_activity_id
      this.dialogForm.company_id = param.company_id
      this.dialogForm.fileProp = param.banner_pic
      this.dialogForm.fileProp2 = param.poster
      this.dialogForm.fileProp3 = param.detail_pic
      this.dialogForm.probability = param.probability
      this.dialogForm.enable = param.is_available
      this.dialogForm.resource = param.applicable_cards
      this.dialogForm.five_name = param.five_company_name
      this.dialogForm.five_activity_num = param.five_activity_num
      this.dialogForm.redemption_codes_num  = param.redemption_codes_num
      this.five_start_time = this.transTime(param.five_start_time)
      this.five_end_time = this.transTime(param.five_end_time)
      this.fileList = [{
          name: this.getImgName(param.banner_pic),
          url: param.banner_pic
      }]
      this.fileList2 = param.poster.split(',').map(item => {
        return {
          name: this.getImgName(item),
          url: item,
        }
      })
      this.fileList3 = param.detail_pic.split(',').map(item => {
        return {
          name: this.getImgName(item),
          url: item,
        }
      })
      this.dialogForm.dateRange  = [new Date(param.start_time), new Date(param.end_time)]
      this.start = this.transTime(param.start_time)
      this.end = this.transTime(param.end_time)
      console.log(this.dialogForm)
    } else {
      this.dialogForm.sortValue = Number(this.$route.query.length) + 1
    }
    this.fetchData()
  },
  mounted() {},

  methods: {
    dateChange(val) {
      if(val){
        const [start, end] = val
        this.start = start + ' 00:00:00'
        this.end = end + ' 23:59:59'
      } else {
        this.start = ''
        this.end = ''
      }
    },
    fetchData(){
      getCompanyList({
        start: '',
        end: '',
        five_company_id: null, // 景区名称
        name: '',
        page: 1,
        page_size: 100000000000000,
      }).then(res => { 
        this.companyList = res.data.data_list
        if(res.data && res.code){
          this.companyList.forEach(item => {
            this.storeList.forEach(key => {
              if(key.storeId == item.five_company_id){
                item.five_company_name = key.storeName
              }
            })
          })
        }
        if(this.type == 'edit'){
          this.changeCom(this.dialogForm.company_id)
        }
      }).catch(e => {})
    },
    getMap1AreaSt(){
      let that = this
      let map1Box = document.getElementById('map1Box')
      // map1Box.addEventListener("wheel", function(e) {
      //   e.preventDefault(); // 阻止默认滚动行为
      //   // 手动计算缩放（可选）
      //   window.map1.enableScrollWheelZoom(true)
      //   // if (e.deltaY < 0) {
      //   //     window.map1.zoomIn();  // 放大
      //   // } else {
      //   //     window.map1.zoomOut(); // 缩小
      //   // }
      //   }, { passive: false })
      map1Box.addEventListener("mouseenter", function() {
        window.map1 && window.map1.enableScrollWheelZoom(true); // 鼠标进入时启用滚轮缩放
        this.addEventListener("wheel", that.handleWheel, { passive: false })
      })
      map1Box.addEventListener("mouseleave", function() {
        window.map1 && window.map1.disableScrollWheelZoom(); // 鼠标离开时禁用（可选）
        this.removeEventListener("wheel", that.handleWheel)
      })
    },
    handleWheel(e) {
      e.preventDefault(); // 阻止页面滚动
      // 手动控制缩放（可选）
      if (e.deltaY < 0) {
        this.smoothZoom(window.map1.getZoom() + 1) // 滚轮向上，放大
      } else {
        this.smoothZoom(window.map1.getZoom() - 1); // 滚轮向下，缩小
      }
    },
    smoothZoom(zoom){
      window.map1.setZoom(zoom)
    },

    handleAdd() {
      this.$router.push("/scenicList");
    },
    handleChange(file) {
      const isLt5M = file.size / 1024 / 1024 < 2;
      if (!isLt5M) {
        this.$message({
          showClose: true,
          message: "文件大小不能超过 2MB",
          type: "warning",
        });
        return false;
      }
    },
    uploadFile(params) {
      let file = params.file;
      let formData = new FormData();
      formData.append("file", file);
      uploadFiles(formData).then(res => {
        if(res.data){
          this.dialogForm.fileProp = res.data.filePath
        }
      }).catch(() => {
        this.handleRemove()
      })
    },
    uploadFile2(params) { 
      let file = params.file
      let formData = new FormData();
      formData.append("file", file);
      uploadFiles(formData).then(res => {
        if(res.data){
          this.dialogForm.fileProp2 = this.dialogForm.fileProp2 ? (this.dialogForm.fileProp2 + ',' + res.data.filePath) : res.data.filePath
          this.fileList2.push({
            url: res.data.filePath,
            name: this.getImgName(res.data.filePath),
          })
        }
      })
    },
    uploadFile3(params){
      let file = params.file;
      let formData = new FormData();
      formData.append("file", file);
      uploadFiles(formData).then(res => {
        if(res.data){
          this.dialogForm.fileProp3 = this.dialogForm.fileProp3 ? (this.dialogForm.fileProp3 + ',' + res.data.filePath) : res.data.filePath
          this.fileList3.push({
            url: res.data.filePath,
            name: this.getImgName(res.data.filePath),
          })
        }
      })
    },
    handleExceed() {
      this.$message.warning('只能上传一张图片，请重新选择！')
    },
    handleExceed2(){
      this.$message.warning('最多只能上传九张图片，请重新选择！')
    },
    submitUpload(file) {
     
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
      this.dialogForm.fileProp = ''
    },
    handleRemove2(file, fileList) {
      const index = this.fileList2.indexOf(file)
      if (index !== -1) {
        this.fileList2.splice(index, 1) // 从列表中移除图片
      }
      if(this.fileList2.length == 0){
        this.dialogForm.fileProp2 = ''
      } else {
        const httpUrls = fileList.map(item => item.url).join(',');
        this.dialogForm.fileProp2 = httpUrls;
      }
    },
    handleRemove3(file, fileList) {
      const index = this.fileList3.indexOf(file)
      if (index !== -1) {
        this.fileList3.splice(index, 1) // 从列表中移除图片
      }
      if(this.fileList3.length == 0){
        this.dialogForm.fileProp3 = ''
      } else {
        const httpUrls = fileList.map(item => item.url).join(',');
        this.dialogForm.fileProp3 = httpUrls;
      }
    },
    changeCom(val){
      const store = this.companyList.find(s => s.id == val)
      console.log(12345, this.companyList, store)
      this.dialogForm.five_name = store.five_company_name
      this.dialogForm.five_company_id = store.five_company_id
      this.getFiveActivList()
      let polygons = JSON.parse(store.location_list)
      this.drawMapArea(polygons)
      let location = store.location.split(',')
      let center = new BMap.Point(location[0], location[1])
      window.map1.setCenter(center)
    },
    getFiveActivList(){
      let id = this.dialogForm.five_company_id * 1
      getFiveActivityListApi({
        id
      }).then(res => {
        if(res && res.data){
          this.fiveActiveList = res.data
          this.changeAct(this.dialogForm.five_activity_id)
        }
      }).catch(e => {})
    },
    changeAct(val){
      const item = this.fiveActiveList.find(s => s.id == val)
      this.dialogForm.five_activity_num = item.totalCouponCount
      this.dialogForm.redemption_codes_num = item.availableCouponCount
      this.dialogForm.storeName = item.storeName
      this.five_start_time = this.transTime(item.startTime)
      this.five_end_time = this.transTime(item.endTime)
      console.log(123456, item)
    },
    drawMapArea(polygons){
      window.map1.clearOverlays()
      let polygon = []
      polygons.forEach(item => {
        polygon.push({
          lng: item.lon,
          lat: item.lat
        })
      })
      let points = []
      polygon.forEach(item => {
        points.push(new BMap.Point(item.lng, item.lat))
      })
      let area = new BMap.Polygon(points, {
        strokeColor: "#96e1fa",
        strokeWeight: 2,
        strokeOpacity: 0.8,
        fillColor: "#1e90ff",
        fillOpacity: 0.6
      })
      this.polygonAreas = polygon
      window.map1.addOverlay(area)
    },
    reset(){
      this.$router.go(-1)
    },
    submitForm() {
      if(!this.dialogForm.five_activity_id){
        this.$message.warning('请选择5.0营销活动')
        return
      }
      console.log(this.dialogForm.five_name, this.dialogForm.storeName)
      if(this.dialogForm.five_name != this.dialogForm.storeName){
        this.$message.warning('5.0景区名称不一致')
        return
      }
      if(this.type == 'add'){
        console.log(this.dialogForm)
        let param = {
          name: this.dialogForm.name,
          company_id: this.dialogForm.company_id,
          poster: this.dialogForm.fileProp2,
          banner_pic: this.dialogForm.fileProp,
          detail_pic: this.dialogForm.fileProp3,
          five_activity_id: this.dialogForm.five_activity_id,
          five_activity_num: this.dialogForm.five_activity_num,
          redemption_codes_num: this.dialogForm.redemption_codes_num,
          start_time: this.start,
          end_time: this.end,
          probability: Number(this.dialogForm.probability),
          is_available: this.dialogForm.enable,
          description: '',
          max_participants: 0,
          order_by: this.dialogForm.sortValue,
          current_participants: 0,
          applicable_cards: this.dialogForm.resource,
          five_start_time: this.five_start_time,
          five_end_time: this.five_end_time,
        }
        this.$refs.dialogForm.validate((valid) => {
          if(valid){
            this.$confirm('确认提交吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              createActivityApi(param).then(res => {
                if(res && res.code){
                  this.$router.go(-1)
                }
              })
            })
          }
        })
      } else {
        let param = {
          name: this.dialogForm.name,
          company_id: this.dialogForm.company_id,
          poster: this.dialogForm.fileProp2,
          banner_pic: this.dialogForm.fileProp,
          detail_pic: this.dialogForm.fileProp3,
          five_activity_id: this.dialogForm.five_activity_id,
          five_activity_num: this.dialogForm.five_activity_num,
          redemption_codes_num: this.dialogForm.redemption_codes_num,
          start_time: this.start,
          end_time: this.end,
          probability: Number(this.dialogForm.probability),
          is_available: this.dialogForm.enable,
          description: '',
          max_participants: 0,
          order_by: this.dialogForm.sortValue,
          current_participants: 0,
          applicable_cards: this.dialogForm.resource,
          id: this.id,
          five_start_time: this.five_start_time,
          five_end_time: this.five_end_time
        }
        console.log(param)
        this.$refs.dialogForm.validate((valid) => {
          if(valid){
            this.$confirm('确认提交吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              updateActivityApi(param).then(res => {
                if(res && res.code){
                  this.$router.go(-1)
                }
              })
            })
          }
        })
      }
    }
  },
  beforeDestroy() {
    window.map1.removeOverlay(this.remark)
    this.drawingManager = null
  },
};
</script>
<style lang="scss" scoped>
.title {
  font-size: 18px;
  font-weight: 700;
}
.titlas {
  display: flex;
  align-items: center;
  margin: 20px 0;
}
.tips {
  color: red;
  font-size: 16px;
  font-weight: 600;
}
.map{
  width: 500px;
  height: 500px;
  position: relative;
  margin: 30px 0 30px 40px;
}
.file-tip{
  color: red;
  font-weight: 600;
}
// .el-form{
//   ::v-deep .el-upload-list{
//     width: 500px;
//   }
// }
.persent{
  color: red;
  font-weight: 600;
  display: inline-block;
  margin-left: 10px;
}
</style>
